import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

export const Container = styled.aside`
  ${({ theme }) => css`
    width: 420px;
    flex-shrink: 0;
    border-left: 1px solid ${theme.colors.background[40]};
    background: ${theme.colors.background[100]};
    position: fixed;
    right: 0;
    top: ${theme.layout.header};
    height: calc(100vh - ${theme.layout.header});
    overflow-y: auto;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: ${theme.colors.background[40]};
      border-radius: 4px;
    }

    ${down('xl')} {
      display: none;
    }
  `}
`;

export const PanelCard = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colors.background[100]};
    border-radius: 1.25rem;
    padding: 1.25rem;
    border: 1px solid ${theme.colors.base.border};
    box-shadow: ${theme.shadows.sm};
  `}
`;

export const PanelCardHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;

    h3 {
      font-size: 1rem;
      font-weight: 700;
      color: ${theme.colors.foreground[100]};
    }

    a {
      font-size: 0.8125rem;
      font-weight: 600;
      color: ${theme.colors.brand.primary.default};
      text-decoration: none;

      :hover {
        text-decoration: underline;
      }
    }
  `}
`;

export const RankingSection = styled.div`
  width: 100%;
`;

export const SidebarEmptyState = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 12rem;
    padding: 1.5rem 1rem;
    gap: 0.5rem;

    > svg {
      color: ${theme.colors.brand.primary.default};
      opacity: 0.85;
      margin-bottom: 0.25rem;
    }

    > strong {
      font-size: 0.875rem;
      font-weight: 600;
      color: ${theme.colors.foreground[100]};
    }

    > span {
      font-size: 0.75rem;
      color: ${theme.colors.foreground[60]};
      line-height: 1.4;
      max-width: 16rem;
    }
  `}
`;

export const Message = styled.div`
  padding: 0.25rem 0.5rem;
`;
